const Mutations = Object.freeze({
	SET_INITIALIZED: 'clientsManagement/SET_INITIALIZED',
	SET_CLIENTS: 'clientsManagement/SET_DATA',
	SET_SELECTED_CLIENT: 'clientsManagement/SET_SELECTED_CLIENT',
	SET_DBCONNECTION: 'clientsManagement/SET_DBCONNECTION',
	SET_LOADING: 'clientsManagement/SET_LOADING',
});
export const Actions = Object.freeze({
	LOAD_DATA: 'clientsManagement/LOAD_DATA',
	LOAD_DATA_BYCLIENTID: 'clientsManagement/LOAD_DATA_BYCLIENTID',
	LOAD_DB_BYCLIENTNAME: 'clientsManagement/LOAD_DB_BYCLIENTNAME',
	INSERT: 'clientsManagement/INSERT',
	INSERT_DBCONNECTION: 'clientsManagement/INSERT_DBCONNECTION',
	UPDATE: 'clientsManagement/UPDATE',
	UPDATE_DBCONNECTION: 'clientsManagement/UPDATE_DBCONNECTION',
	DELETE: 'clientsManagement/DELETE',
	CLEAR: 'clientsManagement/CLEAR',
	REMOVE_LOGO: 'clientsManagement/REMOVE_LOGO',
	CLEAR_SELECTED_CLIENT: 'clientsManagement/CLEAR_SELECTED_CLIENT',
});
export const Getters = Object.freeze({
	GRID_LOADING: 'clientsManagement/GRID_LOADING',
	GET_DATA: 'clientsManagement/GET_DATA',
	GET_SELECTED_CLIENT: 'clientsManagement/GET_SELECTED_CLIENT',
	GET_DBCONNECTION: 'clientsManagement/GET_DBCONNECTION',
	INITIALIZED: 'clientsManagement/INITIALIZED',
});

import { GeneralActions } from '../../actions';
import dataService from '../../../services/clientsManagementService';

export default {
	state: {
		initialized: true,
		loading: false,
		clients: [],
		selectedClient: null,
		dbConnection: null,
	},
	mutations: {
		[Mutations.SET_INITIALIZED](state, value) {
			state.initialized = value;
		},
		[Mutations.SET_CLIENTS](state, items) {
			state.clients = items;
		},
		[Mutations.SET_SELECTED_CLIENT](state, item) {
			state.selectedClient = item;
		},
		[Mutations.SET_DBCONNECTION](state, item) {
			state.dbConnection = item;
		},
		[Mutations.SET_LOADING](state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_CLIENT, null);
				commit(Mutations.SET_DBCONNECTION, null);
				commit(Mutations.SET_CLIENTS, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},
		[Actions.CLEAR_SELECTED_CLIENT]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_CLIENT, null);
				commit(Mutations.SET_DBCONNECTION, null);
				resolve();
			});
		},

		[Actions.LOAD_DATA]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getClients()
					.then((resp) => {
						commit(Mutations.SET_CLIENTS, resp.data);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_DATA_BYCLIENTID]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getClientsById(id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_CLIENT, resp.data);
						if (resp.data.DbConnection) {
							commit(
								Mutations.SET_DBCONNECTION,
								resp.data.DbConnection
							);
						}
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.INSERT]({ commit, dispatch }, client) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let formData = new FormData();
				formData.append('item', JSON.stringify(client.item));
				if (client.logo) {
					formData.append('file', client.logo);
				}
				dataService
					.createClient(formData)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_CLIENT, resp.data);
						if (resp.data.DbConnection) {
							commit(
								Mutations.SET_DBCONNECTION,
								resp.data.DbConnection
							);
						}
						dispatch(GeneralActions.LOADING, false);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.INSERT_DBCONNECTION]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.createDbConnection(item)
					.then((resp) => {
						commit(Mutations.SET_DBCONNECTION, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_DB_BYCLIENTNAME]({ dispatch }, name) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getDbByName(name)
					.then((resp) => {
						dispatch(GeneralActions.LOADING, false);
						if (!resp.data) {
							dispatch(
								GeneralActions.ERROR,
								'Database name already exists'
							);
							resolve(false);
						}
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.UPDATE]({ commit, dispatch }, client) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let formData = new FormData();
				formData.append('item', JSON.stringify(client.item));
				if (client.logo) {
					formData.append('file', client.logo);
				}
				dataService
					.updateClient(formData, client.item.Id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_CLIENT, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},

		[Actions.REMOVE_LOGO]({ commit, dispatch }, client) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.removeClientLogo(client.Id)
					.then(() => {
						client.Logo = null;
						commit(Mutations.SET_SELECTED_CLIENT, client);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.UPDATE_DBCONNECTION]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateDbConnection(item)
					.then(() => {
						commit(Mutations.SET_DBCONNECTION, item);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteClient(id)
					.then(() => {
						commit(Mutations.SET_SELECTED_CLIENT, null);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.INITIALIZED]: (state) => {
			return state.initialized;
		},
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.GET_DATA]: (state) => {
			if (state.clients && state.clients.length > 0) {
				return JSON.parse(
					JSON.stringify(
						state.clients.sort((a, b) => (a.Name > b.Name ? 1 : -1))
					)
				);
			}
		},
		[Getters.GET_SELECTED_CLIENT]: (state) => {
			if (state.selectedClient) {
				return JSON.parse(JSON.stringify(state.selectedClient));
			}
			return null;
		},
		[Getters.GET_DBCONNECTION]: (state) => {
			if (state.dbConnection) {
				return JSON.parse(JSON.stringify(state.dbConnection));
			}
			return null;
		},
	},
};
